import { WebEvaluatorRecorder } from './WebEvaluatorRecorder';
import { WebMusicGradeRecorder } from './WebMusicGradeRecorder';
export class RecorderFactory {
    static createWebMusicGradeRecorder(option) {
        return new WebMusicGradeRecorder(option);
    }
    static createWebEvaluatorRecorder(option) {
        return new WebEvaluatorRecorder(option);
    }
}
